const rtlLanguageCodes = ['ar', 'fa'];

const getLanguageDir = (code: LanguageCode) =>
  rtlLanguageCodes.includes(code) ? 'rtl' : 'ltr';

export default getLanguageDir;
